/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Carousel, CarouselSlide, Image, DotButton } from 'rebass';
import { withState } from 'recompose';
import styled from 'styled-components';
import theme from '../../themes';

const CustomCarouselSlide = styled(CarouselSlide)`
  padding: 0 !important;
`;

const ImageWrapper = styled(Box)`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 1px;
  border: 1px solid ${theme.colors.greyLight};
`;

const CustomDotButton = styled(DotButton)`
  width: 24px !important;
  height: 24px !important;
  outline: 0;
  cursor: pointer;

  &, &:hover, &:focus, &:active {
    background-color: ${props => (props.active ? theme.colors.brand : theme.colors.greyLight)} !important;
  }
`;

const Slider = ({ images, activeIndex, setActiveIndex }) => (
  <Box my={4}>
    <Carousel
      index={activeIndex}
      p={0}
    >
      {
        images.map((image, index) => (
          <CustomCarouselSlide key={index}>
            <ImageWrapper>
              <Image {...image} />
            </ImageWrapper>
          </CustomCarouselSlide>
        ))
      }
    </Carousel>
    {
      images.length > 1 &&
        <Flex justify="center" my={3}>
          {
            images.map((image, index) => (
              <CustomDotButton
                key={index}
                active={index === activeIndex}
                onClick={() => setActiveIndex(index)}
              />
            ))
          }
        </Flex>
    }
  </Box>
);

Slider.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  })),
  activeIndex: PropTypes.number.isRequired,
  setActiveIndex: PropTypes.func.isRequired,
};

Slider.defaultProps = {
  images: [],
};

export default withState('activeIndex', 'setActiveIndex', 0)(Slider);



// WEBPACK FOOTER //
// ./src/app/components/slider/index.js